import { render, staticRenderFns } from "./MerchantLogin.vue?vue&type=template&id=73b99741&"
import script from "./MerchantLogin.vue?vue&type=script&lang=js&"
export * from "./MerchantLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports